import { Avatar, Box, Chip, Accordion as MuiAccordion, Card as MuiCard, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Accordion = styled(MuiAccordion)({
  marginBottom: 8,
  borderRadius: 4,
  border: 'none',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  '&:before': { display: 'none' },
  overflow: 'hidden',
});

export const StatusAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})<{ statusColor: string }>(({ theme, statusColor }) => ({
  backgroundColor: statusColor || '#757575',
  color: theme.palette.common.white,
  width: 40,
  height: 40,
  fontSize: '16px',
  marginRight: '6px'
}));

export const PoiContainer = styled(Box)({
  '&:hover': { backgroundColor: 'action.hover' },
});

export const PoiContent = styled(Box)({
  padding: '16px 8px 8px 8px',
  display: 'flex',
  alignItems: 'center',
});

export const PoiInfo = styled(Box)({
  flexGrow: 1,
});

export const PoiTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const PoiDescription = styled(Typography)(({ theme }) => ({
  marginTop: 4,
  color: theme.palette.text.secondary,
}));

export const ResourceAvatar = styled(Avatar)<{ index: number }>(({ theme, index }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.grey[200],
  border: 2,
  borderColor: theme.palette.background.paper,
  marginLeft: index > 0 ? -4 : 0,
}));

export const MoreResourcesAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.grey[100],
  border: 2,
  borderColor: theme.palette.background.paper,
  marginLeft: -4,
  fontSize: 12,
}));

export const EmptyPOIContainer = styled(Box)({
  padding: 32,
  textAlign: 'center',
});

export const Card = styled(MuiCard)({
  borderRadius: 4,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
});

export const InfoChip = styled(Chip)({
  marginLeft: 8,
  marginRight: 16,
  height: 24,
  fontSize: '0.75rem',
  paddingLeft: '8px !important',
  paddingRight: '6px !important'
});

export const InspectionHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const InspectionInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});